import './Empty.less'
import Empty from './Empty'
export default Empty
